<template>
    <div class="dialog" id="delete-comments-dialog" aria-hidden="true">
        <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
        <div
            role="dialog"
            class="dialog-content dialog-content--add"
            aria-labelledby="my-dialog-title"
            aria-describedby="my-dialog-description"
        >
            <button
                data-a11y-dialog-hide
                class="dialog-close"
                aria-label="Close this dialog window"
            >
                <img src="@/assets/icons/dialog-close.svg" width="24" height="24" alt="Dialog close" />
            </button>

            <div class="add-form__name">{{ $t('project_details.proposal.comments.delete_modal.title') }}</div>
            <div class="add-form__controls">
                    <span>
                        {{ $t('project_details.proposal.comments.delete_modal.description') }}
                    </span>
            </div>
            <div class="dialog__buttons">
                <button class="dialog__button"
                        data-a11y-dialog-hide
                        @click.prevent
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                >{{ $t('project_details.proposal.comments.delete_modal.cancel') }}</button>
                <button class="dialog__button dialog__button--alt"
                        type="submit"
                        :class="{'disabled': sendingForm}"
                        :disabled="sendingForm"
                        @click.prevent="deleteComment"
                >
                    <template v-if="!sendingForm">
                        {{ $t('project_details.proposal.comments.delete_modal.delete') }}
                    </template>
                    <template v-else>
                        {{ $t('project_details.proposal.comments.delete_modal.deleting') }}
                    </template>
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import {onMounted, ref, reactive, watch, inject} from "vue";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";
import router from "@/router";
import {useI18n} from "vue-i18n";

export default {
    name: "confirmDeleteComment",
    emits: ['removeSubcomment','removeComment'],
    setup(props,{emit}) {
        let currentProposalCartId = 0;
        const deleteCommentsModal = ref(),
            {t} = useI18n(),
            alert = inject('alert'),
            commentID = ref([]),
            sendingForm = ref(false);

        onMounted(() => {
            deleteCommentsModal.value = new A11yDialog(document.querySelector("#delete-comments-dialog"));
        });

        function showModal(props, cartProposalId) {
            commentID.value = props;
            currentProposalCartId = cartProposalId
            deleteCommentsModal.value.show();
        }

        function deleteComment() {

            if(commentID.value.length == 1)
                axios.delete(ApiHelper.getRemoveCommentUrl(currentProposalCartId,commentID.value[0]),{
                    headers: authHelper.authHeader()
                })
                    .then(result => {
                        emit('removeComment',commentID.value[0])
                        deleteCommentsModal.value.hide();
                        AlertHelper.show(alert, t('project_details.proposal.comments.success_remove'), '', 'success');
                    })
                    .catch(error => {
                        console.log(error);
                        deleteCommentsModal.value.hide();
                        AlertHelper.show(alert, t('project_details.proposal.comments.fail_remove'), '', 'error');
                    })

            else if(commentID.value.length == 2)
                axios.delete(ApiHelper.getRemoveSubcommentUrl(currentProposalCartId,commentID.value[0],commentID.value[1]),{
                    headers: authHelper.authHeader()
                })
                    .then(result => {
                        emit('removeSubcomment',{
                            commentId: commentID.value[0],
                            subcommentId: commentID.value[1],
                        })
                        deleteCommentsModal.value.hide();
                        AlertHelper.show(alert, t('project_details.proposal.comments.success_remove'), '', 'success');
                    })
                    .catch(error => {
                        deleteCommentsModal.value.hide();
                        AlertHelper.show(alert, t('project_details.proposal.comments.fail_remove'), '', 'error');
                    })
        }


        return {
            showModal,
            sendingForm,
            deleteComment
        }

    }

}
</script>

<style scoped lang="scss">
@use '@/css/_variables';
.dialog__buttons {
    button {
        border: none;
        border-radius: 5px;
        font: normal normal 500 2.0rem/24px Montserrat;
        text-align: center;

        &:hover {
            background: #959595;
        }

        &.dialog__button--alt {
            background: map-get(variables.$colors, default-red);
            color: #fff;

            &:hover {
                background: #e35748;
            }
        }
    }
}
strong {
    font-weight: 800;
}
</style>